import { useQuery } from "@tanstack/react-query";

import type { ApiError } from "@lobby/api-client";
import type { UseQueryOptions } from "@tanstack/react-query";

export function useApiQuery<TData>(options: UseQueryOptions<TData, ApiError>) {
  return useQuery<TData, ApiError>(options);
}
